import React from 'react';

// Catches any render error so one broken component never blanks the whole app
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, ref: null };
  }

  static getDerivedStateFromError() {
    const ref = `CC-FE-${Math.random().toString(16).slice(2, 8).toUpperCase()}`;
    return { hasError: true, ref };
  }

  componentDidCatch(error, info) {
    console.error(`[${this.state.ref}] UI error:`, error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <h1 className="text-xl font-bold text-[#172033] mb-2">Une erreur est survenue</h1>
            <p className="text-sm text-slate-500 mb-2">
              La page a rencontré un problème inattendu. Rechargez pour continuer.
            </p>
            <p className="text-xs text-slate-400 mb-6">Référence : {this.state.ref}</p>
            <button
              onClick={() => { window.location.href = '/'; }}
              className="px-6 py-3 bg-[#2563EB] text-white rounded-full font-semibold text-sm"
              data-testid="error-boundary-home-btn"
            >
              Retourner à CheckCheck
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
